import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class DesignerRating extends React.Component {
    noReviews() {
        return (
            <div>
                <FormattedMessage id="review_summary_none" />
            </div>
        );
    }

    reviewsWithNoStars() {
        return (
            <a href={this.props.reviewUrl} className="link">
                <FormattedMessage
                    id="review_summary_count"
                    values={{ reviewCount: this.props.review.count }}
                />
            </a>
        );
    }

    reviewsAndStars() {
        return (
            <a href={this.props.reviewUrl} className="link">
                <FormattedMessage
                    id="review_star_summary_count"
                    values={{
                        starRating: this.props.review.rating,
                        reviewCount: this.props.review.count,
                    }}
                />
            </a>
        );
    }

    render() {
        let reviewText = null;

        if (this.props.review.count > 1) {
            if (this.props.review.rating) {
                reviewText = this.reviewsAndStars();
            } else {
                reviewText = this.reviewsWithNoStars();
            }
        } else {
            reviewText = this.noReviews();
        }

        return <div className="subtle-text">{reviewText}</div>;
    }
}

DesignerRating.propTypes = {
    reviewUrl: PropTypes.string.isRequired,
    review: PropTypes.shape({
        rating: PropTypes.number,
        count: PropTypes.number,
    }).isRequired,
};

export default DesignerRating;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerRating.jsx